// 新东方集团
import { getCookie } from '../cookie.js'
export const products = [{
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/mtx.png',
  organization: '满天星幼儿园',
  title: '幼儿',
  url: 'http://baby.xdf.cn/',
  style: 'margin-top:-22px;margin-left:-71px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/pop.png',
  organization: '泡泡少儿教育',
  title: '小学',
  url: 'http://souke.xdf.cn/Search?cid=1&ccc=40&gc=0',
  style: 'margin-top:-14px;margin-left:-89px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/yn.png',
  organization: '优能中学教育',
  title: '中学',
  url: `http://souke.xdf.cn/MiddleSchool-${getCookie('soukecityid')}.html`,
  style: 'margin-top:-16px;margin-left:-80px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/qt.png',
  organization: '前途出国',
  title: '留学',
  url: 'http://liuxue.xdf.cn/index3.shtml',
  style: 'margin-top:-16px;margin-left:-71px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/maxen.png',
  organization: '迈格森',
  title: '青少年',
  url: 'http://www.maxen.com.cn/',
  style: 'margin-top:-14px;margin-left:-71px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/yx.png',
  organization: '国际游学',
  title: '游学',
  url: 'http://youxue.xdf.cn/',
  style: 'margin-top:-12px;margin-left:-71px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/koolearn.png',
  organization: '新东方在线',
  title: '网络教育',
  url: 'http://www.koolearn.com/',
  style: 'margin-top:-18px;margin-left:-42px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/shuangyu.png',
  organization: '新东方国际双语学校',
  title: '国际学校',
  url: 'http://noa.xdf.cn/',
  style: 'margin-top:-20px;margin-left:-79px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/tsw.png',
  organization: '新东方图书网',
  title: '图书',
  url: 'http://www.dogwood.com.cn/',
  style: 'margin-top:-17px;margin-left:-76px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/okay.png',
  organization: 'OKAY',
  title: '中小学',
  url: 'http://okay.xdf.cn/',
  style: 'margin-top:-12px;margin-left:-79px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/kxkw.jpg',
  organization: '酷学酷玩',
  title: '训练营',
  url: 'http://coolcamp.xdf.cn/',
  style: 'margin-top:-19px;margin-left:-40px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/lc.jpg',
  organization: '乐词',
  title: '学习工具',
  url: 'http://www.ileci.com/',
  style: 'margin-top:-16px;margin-left:-40px'
},
//  {
//   imgUrl: 'http://file.xdf.cn/neworiental/images/products/bxh.jpg',
//   organization: '百学汇',
//   title: '素质教育',
//   url: 'http://bxh.xdf.cn/',
//   style: 'margin-top:-17px;margin-left:-43px'
// }, 
{
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/oyjy.png',
  organization: '欧亚教育',
  title: '留学',
  url: 'http://liuxue.xdf.cn/asia/Through_train/index.html',
  style: 'margin-top:-18px;left:-10px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/hw.png',
  organization: '海威时代职业教育',
  title: '职业教育',
  url: 'http://www.hwcareer.com/',
  style: 'margin-top:-19px;left:-10px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/zs.jpg',
  organization: '职上网',
  title: '职上网',
  url: 'http://www.51zhishang.com/',
  style: 'margin-top:-21px;margin-left:-54px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/kxdn.png',
  organization: '酷学多纳',
  title: '酷学多纳',
  url: 'http://donut.koolearn.com/',
  style: 'height:40px;margin-top:-20px;margin-left:-77px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/bling.png',
  organization: '新东方青少外教直播',
  title: '青少外教直播',
  url: 'https://www.blingabc.com/',
  style: 'margin-top:-18px;margin-left:-44px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/sfke.png',
  organization: '斯芬克',
  title: '斯芬克',
  url: 'http://www.sfkedu.com',
  style: 'height:40px;margin-top:-20px;margin-left:-36px'
}, {
  imgUrl: 'http://file.xdf.cn/neworiental/images/products/steamxdf.png',
  organization: '斯林姆国际教育',
  title: '斯林姆国际教育',
  url: 'http://www.steamxdf.com',
  style: 'height:40px;margin-top:-20px;margin-left:-64px'
}]



// WEBPACK FOOTER //
// ./src/api/js/home/products.js